import { render, staticRenderFns } from "./EditTicketOld.vue?vue&type=template&id=7b630392&scoped=true"
import script from "./EditTicketOld.vue?vue&type=script&lang=js"
export * from "./EditTicketOld.vue?vue&type=script&lang=js"
import style0 from "./EditTicketOld.vue?vue&type=style&index=0&id=7b630392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b630392",
  null
  
)

export default component.exports